export const ZeroScreenData = {
    noOffer: {
        image: '/images/emptyScreen/noOffer.png',
        title: 'No offers available ',
        subTitle: 'Stay tuned! We are working on adding some amazing offers for you. '
    },
    noNotification: {
        image: '/images/emptyScreen/noNotification.png',
        title: 'No Notifications Yet',
        subTitle: 'Get active on the website to start receiving notifications.'
    },
    noOrder: {
        image: '/images/emptyScreen/noOrder.png',
        title: 'No Order Found',
        subTitle: 'You haven\'t placed any order yet.'
    },
    noProduct: {
        image: '/images/emptyScreen/noProduct.png',
        title: 'Products will be listed soon',
        subTitle: '',
        height: 147, width: 220
    },
    emptyCart: {
        image: '/images/emptyScreen/emptyCart.png',
        title: 'Your Cart Is Feeling Empty',
        subTitle: 'Add some items in your cart to make it happy. '
    },
    noSavedAddress: {
        image: '/images/emptyScreen/noSavedAddress.png',
        title: 'Knock! Knock!',
        subTitle: 'How can we reach you? Save your address '
    },
    noStore: {
        image: '/images/emptyScreen/noStore.png',
        title: 'Store is closed',
        subTitle: 'This chemist store is no longer accepting orders.'
    },
}